module.exports = __webpack_public_path__ + "static/img/14-北京市第十中学.a2f35a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/14-北京市第十中学.png
// module id = c0P9
// module chunks = 0